// This file is generated by pnpm icons:generate. Do not edit.

import {createSinglePathSVG} from './TEMPLATE'

export const Car_Stroke2_Corner2_Rounded = createSinglePathSVG({
  path: 'M22.5 9.75h-1.013l-2.604-5.86a1.5 1.5 0 0 0-1.37-.89H6.487a1.5 1.5 0 0 0-1.37.89L2.513 9.75H1.5a.75.75 0 0 0 0 1.5h.75v7.5a1.5 1.5 0 0 0 1.5 1.5H6a1.5 1.5 0 0 0 1.5-1.5v-1.5h9v1.5a1.5 1.5 0 0 0 1.5 1.5h2.25a1.5 1.5 0 0 0 1.5-1.5v-7.5h.75a.75.75 0 0 0 0-1.5ZM6.488 4.5h11.025l2.333 5.25H4.154ZM6 18.75H3.75v-1.5H6Zm12 0v-1.5h2.25v1.5Zm2.25-3H3.75v-4.5h16.5Zm-15-2.25a.75.75 0 0 1 .75-.75h1.5a.75.75 0 0 1 0 1.5H6a.75.75 0 0 1-.75-.75Zm10.5 0a.75.75 0 0 1 .75-.75H18a.75.75 0 0 1 0 1.5h-1.5a.75.75 0 0 1-.75-.75Z',
  viewBox: '0 0 24 24',
  glyph: 'Car_Stroke2_Corner2_Rounded',
})
